<template>
  <div class="singleNavbar">
    <div class="singleNavbar-content">
      <div class="singleNavbar-button" @click="$store.commit('toggleContactPopupOpen', true);">
        Contact Agent
      </div>
      <div class="singleNavbar-anchors">
        <a class="singleNavbar-anchor" href="#details">Description</a>
        <a class="singleNavbar-anchor" href="#features">Features & Amenities</a>
        <a class="singleNavbar-anchor" href="#location">Location</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
      
    },
  };
</script>

<style lang="scss">

   .singleNavbar {
    position: sticky;
    top: 0;
    left:0;
    height: 120px;
    background: #FFFAF3;
    position: sticky;
    top: 0;
    z-index: 9;
    padding: 30px 100px; 
    box-shadow: 0px 4px 10px 0px rgba(91, 91, 91, 0.14);
    box-shadow: 0px 1px 6px 0px rgba(91, 91, 91, 0.12);
    box-shadow: 0px 1px 2px 0px rgba(91, 91, 91, 0.2);

    @include phone {
        display: none;
    }

    &-content {
       display: flex;
       align-items: center;
       justify-content: space-between;
       height: 100%;
    }
    

    &-button {
      height: 100%;
      background: $red;
      color: white;
      width: 180px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: lowercase;
      font-weight: 600;
      cursor: pointer;
      font-size: 17px;
      position: relative;
      z-index: 1;
      text-transform: uppercase;
      @include middle {
        // min-width: 110px;
        font-size: 16px;
      }
      @include phone {
        width: 100%;
        height: 64px;
        font-size: 24px;
      }
      &:focus {
        filter: brightness(0.5);
      }
    }

     &-anchors {
      display: flex;
      gap: 60px;
      a {
        font-size: 18px;
        font-weight: 600;
        color: #1F1E1E;
        cursor: pointer;
        &:hover {
          color: $red;
        }
      }
    }
   }
</style>